// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(title) {
  return function (onClick) {
    return function (iconOpt) {
      const icon = iconOpt !== undefined ? iconOpt : "";
      return function (reference) {
        return function (disabledOpt) {
          const disabled = disabledOpt !== undefined ? disabledOpt : false;
          return function (classNameOpt) {
            const className = classNameOpt !== undefined ? classNameOpt : "px-3 py-2 gap-1";
            return function (textSizeOpt) {
              const textSize = textSizeOpt !== undefined ? textSizeOpt : "H6";
              let tmp = textSize === "H5" ? JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                      className: "text-white",
                      children: title
                    }) : JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                      className: "text-white",
                      children: title
                    });
              return JsxRuntime.jsxs("button", {
                          ref: reference,
                          children: [
                            tmp,
                            icon === "" ? null : JsxRuntime.jsx("img", {
                                    className: "w-4 h-4",
                                    alt: "",
                                    src: icon
                                  })
                          ],
                          className: Cn.fromList({
                                hd: "bg-links hover:bg-button-primary-hover active:bg-button-primary-active rounded flex items-center disabled:opacity-50 disabled:cursor-not-allowed hover:bg-links-hover active:bg-links-active",
                                tl: {
                                  hd: className,
                                  tl: /* [] */0
                                }
                              }),
                          disabled: disabled,
                          onClick: onClick
                        });
            };
          };
        };
      };
    };
  };
}

function ButtonPrimary(Props) {
  return Curry._5(make(Props.title)(Props.onClick), Props.icon, Props.reference, Props.disabled, Props.className, Props.textSize);
}

const make$1 = ButtonPrimary;

export {
  make$1 as make,
}
/* Buhta_components__Text Not a pure module */
